<p-tabView [(activeIndex)]="index" (onChange)="onTabChange($event)">
  <!-- <p-tabPanel header="{{'Configuration.CRM.Stages' | transloco}}">
    <p-table [value]="contactStages" cdkDropList (cdkDropListDropped)="dropColContact($event)">
      <ng-template pTemplate="header">
        <tr>
          <th style="max-width:3rem"></th>
          <th pReorderableColumn>{{'Configuration.CRM.Name' | transloco}}</th>
          <th pReorderableColumn>{{'Configuration.CRM.Last_Modified' | transloco}}</th>
          <th pReorderableColumn>{{'Configuration.CRM.Action' | transloco}}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-stage let-index="rowIndex">
        <ng-container>
          <tr cdkDrag style="cursor: move;">
            <td class="action" style="width:3rem;max-width:3rem"><span class="pi pi-bars" pReorderableRowHandle></span>
            </td>
            <td pReorderableRowHandle>{{stage.name}}</td>
            <td pReorderableRowHandle>{{stage.updatedDate | date:
              'MM/dd/yyyy'}}</td>
            <td pReorderableRowHandle class="action">
              <span class="btnBars p-mr-0" (click)="editContactStage(stage)" pTooltip="Edit" tooltipPosition="top"><i
                  class="pi pi-pencil"></i></span>
            </td>
          </tr>
        </ng-container>
      </ng-template>
    </p-table>
  </p-tabPanel> -->
  <p-tabPanel header="{{'Configuration.CRM.Template' | transloco}}">
    @if(index==0){
      <app-crm-shared-template [moduleId]="moduleId"></app-crm-shared-template>
    }
  </p-tabPanel>
  <p-tabPanel header="{{'Configuration.CRM.Fields' | transloco}}">
    <p-accordion [(activeIndex)]="activeAccordionIndex" (onOpen)="onOpenAccordion($event)">
      <p-accordionTab header="{{'Configuration.CRM.Annual_Income' | transloco}}">
        <p-table [value]="incomes | orderBy: {property: 'name', direction: 1}" [scrollable]="true" scrollHeight="180px"
          [reorderableColumns]="true">
          <ng-template pTemplate="header">
            <tr>
              <th style="max-width:3rem"></th>
              <th class="p-col-6" pReorderableColumn>{{'Configuration.CRM.Name' | transloco}}</th>
              <th class="p-col-2" pReorderableColumn>Is Active</th>
              <th class="p-col-2" pReorderableColumn>Is Default</th>
              <th class="p-col-2" pReorderableColumn>{{'Configuration.CRM.Action' | transloco}}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-data let-index="rowIndex">
            <tr [pReorderableRow]="index" style="cursor: move;">
              <td style="max-width:3rem" class="action">
                <span class="pi pi-bars" pReorderableRowHandle></span>
              </td>
              <td class="p-col-6" pReorderableRowHandle>{{data.name}}</td>
              <td class="p-col-2" pReorderableRowHandle>
                {{ data.statusId == 1 ? answertypeConstants.Yes : answertypeConstants.No }}
              </td>
              <td class="p-col-2" pReorderableRowHandle>
                <p-radioButton class="p-mr-2" [disabled]="data.isDefault || data.statusId == 2" [value]="true" [(ngModel)]="data.isDefault"
                  (onClick)="makeAnnualIncomeDefault(data)">
                </p-radioButton>
                {{data.isDefault ? answertypeConstants.Yes: answertypeConstants.No}}
              </td>
              <td class="p-col-2 action" pReorderableRowHandle>
                <span class="btnBars p-mr-0" *ngIf="data.organizationId != 0" (click)="showEditContactData(data,
                    contactDataTypes[0], 1)" pTooltip="Edit" tooltipPosition="top"><i class="pi
                      pi-pencil"></i></span>
                <span class="btnBars p-mr-0" *ngIf="data.organizationId != 0 && !data.isDefault" (click)="delAnnualIncome(data)"
                  pTooltip="Delete" tooltipPosition="top"><i class="pi pi-trash"></i></span>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-accordionTab>
      <p-accordionTab header="{{'Configuration.CRM.Contact_Type' | transloco}}" [selected]="true">
        <p-table #db [value]="contactTypes | orderBy: {property: 'name', direction: 1}" [scrollable]="true"
          scrollHeight="180px" [reorderableColumns]="true">
          <ng-template pTemplate="header">
            <tr>
              <th style="max-width:3rem"></th>
              <th class="p-col-6" pReorderableColumn>{{'Configuration.CRM.Name' | transloco}}</th>
              <th class="p-col-2" pReorderableColumn>Is Active</th>
              <th class="p-col-2" pReorderableColumn>Is Default</th>
              <th class="p-col-2" pReorderableColumn>{{'Configuration.CRM.Action' | transloco}}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-data let-index="rowIndex">
            <tr [pReorderableRow]="index" style="cursor: move;">
              <td style="max-width:3rem" class="action">
                <span class="pi pi-bars" pReorderableRowHandle></span>
              </td>
              <td class="p-col-6" pReorderableRowHandle>{{data.name}}</td>
              <td class="p-col-2" pReorderableRowHandle>
                {{ data.statusId == 1 ? answertypeConstants.Yes : answertypeConstants.No }}
              </td>
              <td class="p-col-2" pReorderableRowHandle>
                <p-radioButton class="p-mr-2" [disabled]="data.isDefault || data.statusId == 2" [value]="true" [(ngModel)]="data.isDefault"
                  (onClick)="makeContactTypeDefault(data)">
                </p-radioButton>
                {{data.isDefault ? answertypeConstants.Yes: answertypeConstants.No}}
              </td>
              <td class="p-col-2 action" pReorderableRowHandle>
                <span class="btnBars p-mr-0" (click)="showEditContactData(data,
                    contactDataTypes[1], 1)" pTooltip="Edit" tooltipPosition="top"><i class="pi
                      pi-pencil"></i></span>
                <span class="btnBars p-mr-0" (click)="delContactType(data)" pTooltip="Delete" tooltipPosition="top"><i
                    class="pi pi-trash" *ngIf="!data.isDefault"></i></span>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-accordionTab>
      <p-accordionTab header="{{'Configuration.CRM.Degree' | transloco}}">
        <p-table [value]="degrees | orderBy: {property: 'name', direction: 1}" [scrollable]="true" scrollHeight="180px"
          [reorderableColumns]="true">
          <ng-template pTemplate="header">
            <tr>
              <th style="max-width:3rem"></th>
              <th class="p-col-6" pReorderableColumn>{{'Configuration.CRM.Name' | transloco}}</th>
              <th class="p-col-2" pReorderableColumn>Is Active</th>
              <th class="p-col-2" pReorderableColumn>Is Default</th>
              <th class="p-col-2" pReorderableColumn>{{'Configuration.CRM.Action' | transloco}}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-data let-index="rowIndex">
            <tr [pReorderableRow]="index" style="cursor: move;">
              <td style="max-width:3rem" class="action">
                <span class="pi pi-bars" pReorderableRowHandle></span>
              </td>
              <td class="p-col-6" pReorderableRowHandle>{{data.name}}</td>
              <td class="p-col-2" pReorderableRowHandle>
                {{ data.statusId == 1 ? answertypeConstants.Yes : answertypeConstants.No }}
              </td>
              <td class="p-col-2" pReorderableRowHandle>
                <p-radioButton class="p-mr-2" [disabled]="data.isDefault || data.statusId == 2" [value]="true" [(ngModel)]="data.isDefault"
                  (onClick)="makeDegreeDefault(data)">
                </p-radioButton>
                {{data.isDefault ? answertypeConstants.Yes: answertypeConstants.No}}
              </td>
              <td class="p-col-2 action" pReorderableRowHandle>
                <span class="btnBars p-mr-0" *ngIf="data.organizationId != 0" (click)="showEditContactData(data,
                    contactDataTypes[2], 1)" pTooltip="Edit" tooltipPosition="top"><i class="pi
                      pi-pencil"></i></span>
                <span class="btnBars p-mr-0" *ngIf="data.organizationId != 0 && !data.isDefault" (click)="delDegree(data)"
                  pTooltip="Delete" tooltipPosition="top"><i class="pi pi-trash"></i></span>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-accordionTab>
      <p-accordionTab header="{{'Configuration.CRM.Email_Type' | transloco}}">
        <p-table [value]="emailtype | orderBy: {property: 'name', direction: 1}" [scrollable]="true"
          scrollHeight="180px" [reorderableColumns]="true">
          <ng-template pTemplate="header">
            <tr>
              <th style="max-width:3rem"></th>
              <th class="p-col-10" pReorderableColumn>{{'Configuration.CRM.Name' | transloco}}</th>
              <th class="p-col-2" pReorderableColumn>{{'Configuration.CRM.Action' | transloco}}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-data let-index="rowIndex">
            <tr [pReorderableRow]="index" style="cursor: move;">
              <td style="max-width:3rem" class="action">
                <span class="pi pi-bars" pReorderableRowHandle></span>
              </td>
              <td class="p-col-10" pReorderableRowHandle>{{data.name}}</td>
              <td class="p-col-2 action" pReorderableRowHandle>
                <span class="btnBars p-mr-0" (click)="showEditContactData(data,
                    contactDataTypes[3], 3)" pTooltip="Edit" tooltipPosition="top"><i class="pi
                      pi-pencil"></i></span>
                <span class="btnBars p-mr-0" *ngIf="!data.systemGenerated" (click)="delEmailType(index)"
                  pTooltip="Delete" tooltipPosition="top"><i class="pi pi-trash"></i></span>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-accordionTab>
      <p-accordionTab header="{{'Configuration.CRM.Field_Of_Study' | transloco}}">
        <p-table [value]="studyFields | orderBy: {property: 'name', direction: 1}" [scrollable]="true"
          scrollHeight="180px" [reorderableColumns]="true">
          <ng-template pTemplate="header">
            <tr>
              <th style="max-width:3rem"></th>
              <th class="p-col-6" pReorderableColumn>{{'Configuration.CRM.Name' | transloco}}</th>
              <th class="p-col-2" pReorderableColumn>Is Active</th>
              <th class="p-col-2" pReorderableColumn>Is Default</th>
              <th class="p-col-2" pReorderableColumn>{{'Configuration.CRM.Action' | transloco}}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-data let-index="rowIndex">
            <tr [pReorderableRow]="index" style="cursor: move;">
              <td style="max-width:3rem" class="action">
                <span class="pi pi-bars" pReorderableRowHandle></span>
              </td>
              <td class="p-col-6" pReorderableRowHandle>{{data.name}}</td>
              <td class="p-col-2" pReorderableRowHandle>
                {{ data.statusId == 1 ? answertypeConstants.Yes : answertypeConstants.No }}
              </td>
              <td class="p-col-2" pReorderableRowHandle>
                <p-radioButton class="p-mr-2" [disabled]="data.isDefault || data.statusId == 2" [value]="true" [(ngModel)]="data.isDefault"
                  (onClick)="makeStudyFieldDefault(data)">
                </p-radioButton>
                {{data.isDefault ? answertypeConstants.Yes: answertypeConstants.No}}
              </td>
              <td class="p-col-2 action" pReorderableRowHandle>
                <span class="btnBars p-mr-0" *ngIf="data.organizationId != 0" (click)="showEditContactData(data,
                    contactDataTypes[4], 4)" pTooltip="Edit" tooltipPosition="top"><i class="pi
                      pi-pencil"></i></span>
                <span class="btnBars p-mr-0" *ngIf="data.organizationId != 0 && !data.isDefault" (click)="delStudyField(data)"
                  pTooltip="Delete" tooltipPosition="top"><i class="pi pi-trash"></i></span>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-accordionTab>
      <p-accordionTab header="{{'Configuration.CRM.Gender' | transloco}}">
        <p-table [value]="genders | orderBy: {property: 'name', direction: 1}" [scrollable]="true" scrollHeight="180px"
          [reorderableColumns]="true">
          <ng-template pTemplate="header">
            <tr>
              <th style="max-width:3rem"></th>
              <th class="p-col-6" pReorderableColumn>{{'Configuration.CRM.Name' | transloco}}</th>
              <th class="p-col-2" pReorderableColumn>Is Active</th>
              <th class="p-col-2" pReorderableColumn>Is Default</th>
              <th class="p-col-2" pReorderableColumn>{{'Configuration.CRM.Action' | transloco}}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-data let-index="rowIndex">
            <tr [pReorderableRow]="index" style="cursor: move;">
              <td style="max-width:3rem" class="action">
                <span class="pi pi-bars" pReorderableRowHandle></span>
              </td>
              <!-- <pre>{{data | json}}</pre> -->
              <td class="p-col-6" pReorderableRowHandle>{{data.name}}</td>
              <td class="p-col-2" pReorderableRowHandle>
                {{ data.statusId == 1 ? answertypeConstants.Yes : answertypeConstants.No }}
              </td>
              <td class="p-col-2" pReorderableRowHandle>
                <p-radioButton class="p-mr-2" [disabled]="data.isDefault || data.statusId == 2" [value]="true" [(ngModel)]="data.isDefault"
                  (onClick)="makeGenderDefault(data)">
                </p-radioButton>
                {{data.isDefault ? answertypeConstants.Yes: answertypeConstants.No}}
              </td>
              <td class="p-col-2 action" pReorderableRowHandle>
                <span class="btnBars p-mr-0" *ngIf="data.organizationId != 0" (click)="showEditContactData(data,
                    contactDataTypes[5], 5)" pTooltip="Edit" tooltipPosition="top"><i class="pi
                      pi-pencil"></i></span>
                <span class="btnBars p-mr-0" *ngIf="data.organizationId != 0 && !data.isDefault" (click)="delGender(data)"
                  pTooltip="Delete" tooltipPosition="top"><i class="pi pi-trash"></i></span>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-accordionTab>
      <p-accordionTab header="{{'Configuration.CRM.Language_Spoken' | transloco}}">
        <p-table [value]="languages | orderBy: {property: 'name', direction: 1}" [scrollable]="true"
          scrollHeight="180px" [reorderableColumns]="true">
          <ng-template pTemplate="header">
            <tr>
              <th style="max-width:3rem"></th>
              <th class="p-col-10" pReorderableColumn>{{'Configuration.CRM.Name' | transloco}}</th>
              <th class="p-col-2" pReorderableColumn>{{'Configuration.CRM.Action' | transloco}}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-data let-index="rowIndex">
            <tr [pReorderableRow]="index" style="cursor: move;">
              <td style="max-width:3rem" class="action">
                <span class="pi pi-bars" pReorderableRowHandle></span>
              </td>
              <td class="p-col-10" pReorderableRowHandle>{{data.name}}</td>
              <td class="p-col-2 action" pReorderableRowHandle>
                <span class="btnBars p-mr-0" (click)="showEditContactData(data,
                    contactDataTypes[6], 6)" pTooltip="Edit" tooltipPosition="top"><i class="pi
                      pi-pencil"></i></span>
                <span class="btnBars p-mr-0" (click)="delLanguage(data)" pTooltip="Delete" tooltipPosition="top"><i
                    class="pi pi-trash"></i></span>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-accordionTab>
      <p-accordionTab header="{{'Configuration.CRM.Marital_Status' | transloco}}">
        <p-table [value]="maritals | orderBy: {property: 'name', direction: 1}" [scrollable]="true" scrollHeight="180px"
          [reorderableColumns]="true">
          <ng-template pTemplate="header">
            <tr>
              <th style="max-width:3rem"></th>
              <th class="p-col-10" pReorderableColumn>{{'Configuration.CRM.Name' | transloco}}</th>
              <th class="p-col-2" pReorderableColumn>{{'Configuration.CRM.Action' | transloco}}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-data let-index="rowIndex">
            <tr [pReorderableRow]="index" style="cursor: move;">
              <td style="max-width:3rem" class="action">
                <span class="pi pi-bars" pReorderableRowHandle></span>
              </td>
              <td class="p-col-10" pReorderableRowHandle>{{data.name}}</td>
              <td class="p-col-2 action" pReorderableRowHandle>
                <span class="btnBars p-mr-0" (click)="showEditContactData(data,
                    contactDataTypes[7], 7)" pTooltip="Edit" tooltipPosition="top"><i class="pi
                      pi-pencil"></i></span>
                <span class="btnBars p-mr-0" (click)="delMaritalStatus(data)" pTooltip="Delete" tooltipPosition="top"><i
                    class="pi pi-trash"></i></span>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-accordionTab>
      <p-accordionTab header="{{'Configuration.CRM.Phone_Type' | transloco}}">
        <p-table [value]="phonetype | orderBy: {property: 'name', direction: 1}" [scrollable]="true"
          scrollHeight="180px" [reorderableColumns]="true">
          <ng-template pTemplate="header">
            <tr>
              <th style="max-width:3rem"></th>
              <th class="p-col-10" pReorderableColumn>{{'Configuration.CRM.Name' | transloco}}</th>
              <th class="p-col-2" pReorderableColumn>{{'Configuration.CRM.Action' | transloco}}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-data let-index="rowIndex">
            <tr [pReorderableRow]="index" style="cursor: move;">
              <td style="max-width:3rem" class="action">
                <span class="pi pi-bars" pReorderableRowHandle></span>
              </td>
              <td class="p-col-10" pReorderableRowHandle>{{data.name}}</td>
              <td class="p-col-2 action" pReorderableRowHandle>
                <span class="btnBars p-mr-0" (click)="showEditContactData(data,
                    contactDataTypes[8], 8)" pTooltip="Edit" tooltipPosition="top"><i class="pi
                      pi-pencil"></i></span>
                <span class="btnBars p-mr-0" *ngIf="!data.systemGenerated" (click)="delPhoneType(index)"
                  pTooltip="Delete" tooltipPosition="top"><i class="pi pi-trash"></i></span>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-accordionTab>
      <p-accordionTab header="{{'Configuration.CRM.Relationship_Status' | transloco}}">
        <p-table [value]="relations | orderBy: {property: 'name', direction: 1}" [scrollable]="true"
          scrollHeight="180px" [reorderableColumns]="true">
          <ng-template pTemplate="header">
            <tr>
              <th style="max-width:3rem"></th>
              <th class="p-col-10" pReorderableColumn>{{'Configuration.CRM.Name' | transloco}}</th>
              <th class="p-col-2" pReorderableColumn>{{'Configuration.CRM.Action' | transloco}}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-data let-index="rowIndex">
            <tr [pReorderableRow]="index" style="cursor: move;">
              <td style="max-width:3rem" class="action">
                <span class="pi pi-bars" pReorderableRowHandle></span>
              </td>
              <td class="p-col-10" pReorderableRowHandle>{{data.name}}</td>
              <td class="p-col-2 action" pReorderableRowHandle>
                <span class="btnBars p-mr-0" (click)="showEditContactData(data,
                    contactDataTypes[9], 9)" pTooltip="Edit" tooltipPosition="top"><i class="pi
                      pi-pencil"></i></span>
                <span class="btnBars p-mr-0" (click)="delRelationshipStatus(data)" pTooltip="Delete"
                  tooltipPosition="top"><i class="pi pi-trash"></i></span>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-accordionTab>
      <p-accordionTab header="{{'Configuration.CRM.Social_Profile_Type' | transloco}}">
        <p-table [value]="socials | orderBy: {property: 'name', direction: 1}" [scrollable]="true" scrollHeight="180px"
          [reorderableColumns]="true">
          <ng-template pTemplate="header">
            <tr>
              <th style="max-width:3rem"></th>
              <th class="p-col-10" pReorderableColumn>{{'Configuration.CRM.Name' | transloco}}</th>
              <th class="p-col-2" pReorderableColumn>{{'Configuration.CRM.Action' | transloco}}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-data let-index="rowIndex">
            <tr [pReorderableRow]="index" style="cursor: move;">
              <td style="max-width:3rem" class="action">
                <span class="pi pi-bars" pReorderableRowHandle></span>
              </td>
              <td class="p-col-10" pReorderableRowHandle>{{data.name}}</td>
              <td class="p-col-2 action" pReorderableRowHandle>
                <span class="btnBars p-mr-0" (click)="showEditContactData(data,
                    contactDataTypes[10], 10)" pTooltip="Edit" tooltipPosition="top"><i class="pi
                      pi-pencil"></i></span>
                <span class="btnBars p-mr-0" *ngIf="!data.systemGenerated" (click)="delSocialType(index)"
                  pTooltip="Delete" tooltipPosition="top"><i class="pi pi-trash"></i></span>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-accordionTab>
      <p-accordionTab header="{{'Configuration.CRM.Source_Of_Contact' | transloco}}">
        <p-table [value]="contactSources | orderBy: {property: 'name', direction: 1}" [scrollable]="true"
          scrollHeight="180px" [reorderableColumns]="true">
          <ng-template pTemplate="header">
            <tr>
              <th style="max-width:3rem"></th>
              <th class="p-col-6" pReorderableColumn>{{'Configuration.CRM.Name' | transloco}}</th>
              <th class="p-col-2" pReorderableColumn>Is Active</th>
              <th class="p-col-2" pReorderableColumn>Is Default</th>
              <th class="p-col-2" pReorderableColumn>{{'Configuration.CRM.Action' | transloco}}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-data let-index="rowIndex">
            <tr [pReorderableRow]="index" style="cursor: move;">
              <td style="max-width:3rem" class="action">
                <span class="pi pi-bars" pReorderableRowHandle></span>
              </td>
              <td class="p-col-6" pReorderableRowHandle>{{data.name}}</td>
              <td class="p-col-2" pReorderableRowHandle>
                {{ data.statusId == 1 ? answertypeConstants.Yes : answertypeConstants.No }}
              </td>
              <td class="p-col-2" pReorderableRowHandle>
                <p-radioButton class="p-mr-2" [disabled]="data.isDefault || data.statusId == 2" [value]="true" [(ngModel)]="data.isDefault"
                  (onClick)="makeContactSourceDefault(data)">
                </p-radioButton>
                {{data.isDefault ? answertypeConstants.Yes: answertypeConstants.No}}
              </td>
              <td class="p-col-2 action" pReorderableRowHandle>
                <span class="btnBars p-mr-0" *ngIf="data.organizationId != 0" (click)="showEditContactData(data,
                    contactDataTypes[11], 11)" pTooltip="Edit" tooltipPosition="top"><i class="pi
                      pi-pencil"></i></span>
                <span class="btnBars p-mr-0" *ngIf="data.organizationId != 0 && !data.isDefault" (click)="delContactSource(data)"
                  pTooltip="Delete" tooltipPosition="top"><i class="pi pi-trash"></i></span>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-accordionTab>
      <p-accordionTab header="{{'Configuration.CRM.Roles' | transloco}}">
        <p-table [value]="contactDesignation" [scrollable]="true" scrollHeight="180px" [reorderableColumns]="true">
          <ng-template pTemplate="header">
            <tr>
              <th style="max-width:3rem"></th>
              <th class="p-col-6" pReorderableColumn>{{'Configuration.CRM.Name' | transloco}}</th>
              <th class="p-col-2" pReorderableColumn>Is Active</th>
              <th class="p-col-2" pReorderableColumn>Is Default</th>
              <th class="p-col-2" pReorderableColumn>{{'Configuration.CRM.Action' | transloco}}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-data let-index="rowIndex">
            <tr [pReorderableRow]="index" style="cursor: move;">
              <td style="max-width:3rem" class="action">
                <span class="pi pi-bars" pReorderableRowHandle></span>
              </td>
              <td class="p-col-6" pReorderableRowHandle>{{data.name}}</td>
              <td class="p-col-2" pReorderableRowHandle>
                {{ data.statusId == 1 ? answertypeConstants.Yes : answertypeConstants.No }}
              </td>
              <td class="p-col-2" pReorderableRowHandle>
                <p-radioButton class="p-mr-2" [disabled]="data.isDefault || data.statusId == 2" [value]="true" [(ngModel)]="data.isDefault"
                  (onClick)="makeContactDesignationDefault(data)">
                </p-radioButton>
                {{data.isDefault ? answertypeConstants.Yes: answertypeConstants.No}}
              </td>
              <td class="p-col-2 action" pReorderableRowHandle>
                <span class="btnBars p-mr-0" (click)="showEditContactData(data,
                    contactDataTypes[12], 12)" pTooltip="Edit" tooltipPosition="top"><i class="pi
                      pi-pencil"></i></span>
                <span class="btnBars p-mr-0" (click)="delContactDesignation(data)" pTooltip="Delete" tooltipPosition="top"><i
                    class="pi pi-trash" *ngIf="!data.isDefault"></i></span>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-accordionTab>
      <p-accordionTab header="{{'Configuration.CRM.Title' | transloco}}">
        <p-table [value]="salutations" [scrollable]="true" scrollHeight="180px" [reorderableColumns]="true">
          <ng-template pTemplate="header">
            <tr>
              <th style="max-width:3rem"></th>
              <th class="p-col-6" pReorderableColumn>{{'Configuration.CRM.Name' | transloco}}</th>
              <th class="p-col-2" pReorderableColumn>Is Active</th>
              <th class="p-col-2" pReorderableColumn>Is Default</th>
              <th class="p-col-2" pReorderableColumn>{{'Configuration.CRM.Action' | transloco}}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-data let-index="rowIndex">
            <tr [pReorderableRow]="index" style="cursor: move;">
              <td style="max-width:3rem" class="action">
                <span class="pi pi-bars" pReorderableRowHandle></span>
              </td>
              <td class="p-col-6" pReorderableRowHandle>{{data.name}}</td>
              <td class="p-col-2" pReorderableRowHandle>
                {{ data.statusId === 1 ? answertypeConstants.Yes : answertypeConstants.No }}
              </td>
              <td class="p-col-2" pReorderableRowHandle>
                <p-radioButton class="p-mr-2" [disabled]="data.isDefault || data.statusId == 2" [value]="true" [(ngModel)]="data.isDefault"
                  (onClick)="makeSalutationDefault(data)">
                </p-radioButton>
                {{data.isDefault ? answertypeConstants.Yes: answertypeConstants.No}}
              </td>
              <td class="p-col-2 action" pReorderableRowHandle>
                <span class="btnBars p-mr-0" (click)="showEditContactData(data,
                    contactDataTypes[13], 13)" pTooltip="Edit" tooltipPosition="top"><i class="pi
                      pi-pencil"></i></span>
                <span class="btnBars p-mr-0" *ngIf="!data.isDefault" (click)="delSalutation(data)" pTooltip="Delete"
                  tooltipPosition="top"><i class="pi pi-trash"></i></span>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-accordionTab>
      <p-accordionTab header="Active Reason">
        <p-table [value]="activeReason" [scrollable]="true" scrollHeight="180px">
          <ng-template pTemplate="header">
            <tr>
              <th class="p-col-6">Name</th>
              <th class="p-col-2">Is Active</th>
              <th class="p-col-2">Is Default</th>
              <th class="p-col-2">Action</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-data let-index="rowIndex">
            <tr style="cursor: move;">
              <td class="p-col-6">{{ data.name }}</td>
              <td class="p-col-2">{{ data.statusId==1 ? answertypeConstants.Yes : answertypeConstants.No }}</td>
              <td class="p-col-2">
                <p-radioButton [disabled]="data.isDefault || data.statusId == 2" [value]="true" [(ngModel)]="data.isDefault"
                  (onClick)="makeActiveInactiveDefault(data)"></p-radioButton>
                {{data.isDefault ? answertypeConstants.Yes: answertypeConstants.No}}
              </td>
              <td class="p-col-2 action">
                <span class="btnBars p-mr-0" (click)="showEditContactData(data, contactDataTypes[14], 14)"
                  pTooltip="Edit" tooltipPosition="top"><i class="pi pi-pencil"></i></span>
                <span class="btnBars p-mr-0" (click)="deleteActiveInactiveReason(data, contactDataTypes[14])"
                  pTooltip="Delete" tooltipPosition="top" *ngIf="data.isDefault == false"><i
                    class="pi pi-trash"></i></span>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-accordionTab>
      <p-accordionTab header="Inactive Reason">
        <p-table [value]="inactiveReason" [scrollable]="true" scrollHeight="180px">
          <ng-template pTemplate="header">
            <tr>
              <th class="p-col-6">Name</th>
              <th class="p-col-2">Is Active</th>
              <th class="p-col-2">Is Default</th>
              <th class="p-col-2">Action</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-data let-index="rowIndex">
            <tr style="cursor: move;">
              <td class="p-col-6">{{ data.name }}</td>
              <td class="p-col-2">{{ data.statusId==1 ? answertypeConstants.Yes : answertypeConstants.No }}</td>
              <td class="p-col-2">
                <p-radioButton [disabled]="data.isDefault || data.statusId == 2" [value]="true" [(ngModel)]="data.isDefault"
                  (onClick)="makeActiveInactiveDefault(data)"></p-radioButton>
                {{data.isDefault ? answertypeConstants.Yes: answertypeConstants.No}}
              </td>
              <td class="p-col-2 action">
                <span class="btnBars p-mr-0" (click)="showEditContactData(data, contactDataTypes[15], 15)"
                  pTooltip="Edit" tooltipPosition="top"><i class="pi pi-pencil"></i></span>
                <span class="btnBars p-mr-0" (click)="deleteActiveInactiveReason(data, contactDataTypes[15])"
                  pTooltip="Delete" tooltipPosition="top" *ngIf="data.isDefault == false"><i
                    class="pi pi-trash"></i></span>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-accordionTab>
      <p-accordionTab header="Tags">
        <p-table [value]="tagList" [scrollable]="true" scrollHeight="180px">
          <ng-template pTemplate="header">
            <tr>
              <th style="max-width:3rem"></th>
              <th class="p-col-6">Name</th>
              <th class="p-col-2">Is Active</th>
              <th class="p-col-2">Action</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-data let-index="rowIndex">
            <tr>
              <td style="max-width:3rem" class="action">
                <span class="pi pi-bars"></span>
              </td>
              <td class="p-col-6">
                <p-tag [value]="data?.name" class="p-ml-2" [style]="{'background-color': data?.color}"></p-tag>
              </td>
              <td class="p-col-2">{{ data.statusId==1 ? answertypeConstants.Yes : answertypeConstants.No }}</td>
              <td class="p-col-2 action">
                <span *ngIf="data.organizationId != 0" class="btnBars p-mr-0"  pTooltip="Edit"
                  tooltipPosition="top" (click)="showEditTag(data)">
                  <i class="pi pi-pencil"></i>
                </span>
                <span *ngIf="data.organizationId != 0" class="btnBars p-mr-0" pTooltip="Delete" tooltipPosition="top"
                (click)="deleteTag(data)">
                  <i class="pi pi-trash"></i>
                </span>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-accordionTab>
      <!-- new Field Contact Roles -->
      <p-accordionTab header= "Contact Roles">
        <p-table [value]="contactRoles" [scrollable]="true" scrollHeight="180px" [reorderableColumns]="true">
          <ng-template pTemplate="header">
            <tr>
              <th style="max-width:3rem"></th>
              <th class="p-col-6" pReorderableColumn>{{'Configuration.CRM.Name' | transloco}}</th>
              <th class="p-col-2" pReorderableColumn>Is Active</th>
              <th class="p-col-2" pReorderableColumn>Is Default</th>
              <th class="p-col-2" pReorderableColumn>{{'Configuration.CRM.Action' | transloco}}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-data let-index="rowIndex">
            <tr [pReorderableRow]="index" style="cursor: move;">
              <td style="max-width:3rem" class="action">
                <span class="pi pi-bars" pReorderableRowHandle></span>
              </td>
              <td class="p-col-6" pReorderableRowHandle>{{data.name}}</td>
              <td class="p-col-2" pReorderableRowHandle>
                {{ data.statusId == 1 ? answertypeConstants.Yes : answertypeConstants.No }}
              </td>
              <td class="p-col-2" pReorderableRowHandle>
                <p-radioButton class="p-mr-2" [disabled]="data.isDefault || data.statusId == 2" [value]="true" [(ngModel)]="data.isDefault"
                  (onClick)="makeContactRoleDefault(data)">
                </p-radioButton>
                {{data.isDefault ? answertypeConstants.Yes: answertypeConstants.No}}
              </td>
              <td class="p-col-2 action" pReorderableRowHandle>
                <span class="btnBars p-mr-0" (click)="showEditContactData(data,
                    contactDataTypes[17], 17)" pTooltip="Edit" tooltipPosition="top"><i class="pi
                      pi-pencil"></i></span>
                <span class="btnBars p-mr-0" (click)="delContactRole(data)" pTooltip="Delete" tooltipPosition="top"><i
                    class="pi pi-trash" *ngIf="!data.isDefault"></i></span>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-accordionTab>
    </p-accordion>
  </p-tabPanel>
  <p-tabPanel [disabled]="true" headerStyleClass="iconPanel">
    <ng-template pTemplate="header">
      <p-menu #configmenuLead id="config_menu_contact" [model]="configMenuContactItems" [popup]="true"
        appendTo="body"></p-menu>
      <span class="btnBars p-mr-0" (click)="configmenuLead.toggle($event)">
        <i class="pi pi-bars"></i>
      </span>
    </ng-template>
  </p-tabPanel>
</p-tabView>

<p-dialog header="{{addEditContactHeader}}" [modal]="true" [(visible)]="displayAddContactStage"
  [style]="{width: '50vw'}" [baseZIndex]="10000">
  <div class="p-grid">
    <div class="p-col-12">
      <label for="name">{{'Configuration.CRM.Name' | transloco}}</label>
      <input type="text" pInputText [(ngModel)]="tempContactStage.name">
    </div>
    <div class="p-col-12">
      <label for="name">{{'Configuration.CRM.Description' | transloco}}</label>
      <input type="text" pInputText style="width: 100%;" [(ngModel)]="tempContactStage.description">
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button pButton (click)="displayAddContactStage=false" label="{{'Configuration.CRM.Cancel' | transloco}}"
      class="p-button-secondary"></button>
    <button pButton (click)="saveContactEditStage()" label="{{'Configuration.CRM.Save' | transloco}}"></button>
  </ng-template>
</p-dialog>

<p-dialog header="{{'Configuration.CRM.Template' | transloco}} - {{'Configuration.CRM.Contact' | transloco}}"
  [(visible)]="displayEditContactTemplate" [modal]="true" [responsive]="true" [style]="{width: '60em'}">
  <form #contactTemplateForm="ngForm">
    <div class="card">
      <div class="p-grid">
        <div class="p-col-12 p-pr-2 p-pl-2">
          <div class="p-grid">
            <h6 class="p-col-4 p-mb-2 p-pl-4">{{'Configuration.CRM.Label_Name' | transloco}}</h6>
            <h6 class="p-col-6 p-mb-2 p-pl-4">{{'Configuration.CRM.Edit_Label_Name' | transloco}}</h6>
            <div style="width:50px" class="p-mb-2 p-text-center">
              <span class="btnBars" style="cursor: default;" pTooltip="{{'Configuration.CRM.Fields' | transloco}}"
                tooltipPosition="top">
                <i class="pi pi-file" style="font-size: 15px;"></i>
              </span>
            </div>
            <div style="width:50px" class="p-mb-2 p-text-center">
              <span class="btnBars" style="cursor: default;" pTooltip="{{'Configuration.CRM.Setting' | transloco}}"
                tooltipPosition="top">
                <i class="pi pi-cog" style="font-size: 15px;"></i>
              </span>
            </div>
          </div>
          <p-table [value]="selectedContactLabels_info" dataKey="id" styleClass="editable">
            <ng-template pTemplate="header">
              <tr>
                <th class="header p-col-4">
                  <h5>
                    {{'Configuration.CRM.Contact_Information' | transloco}}
                  </h5>
                </th>
                <th class="header p-col-6"></th>
                <th style="width: 50px;" class="p-text-center header">
                  <p-checkbox [ngModelOptions]="{standalone: true}" (click)="selectedContactRow1(ct1.checked,
                    row1CheckBoxStateValue)" #ct1 ngDefaultControl [(ngModel)]="selectedContactCheck1" binary="true">
                  </p-checkbox>
                </th>
                <th style="width: 50px;" class="p-text-center header">
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-label let-expanded="expanded">
              <tr>
                <td>
                  {{label.name}}
                  <span style="color: red;" *ngIf="label.movable == false && label.width !== 2">*</span>
                  <button type="button" pButton pRipple [pRowToggler]="label" style="width: 1.25rem;height: 1.25rem;"
                    class="p-button-text p-button-rounded p-p-0 p-ml-2" [icon]="expanded ? 'pi pi-minus' : 'pi pi-plus'"
                    *ngIf="['email', 'phone', 'social'].includes(label.code)">
                  </button>
                </td>
                <td pEditableColumn class="action">
                  <input pInputText type="text" [ngModelOptions]="{standalone: true}" [(ngModel)]="label.labelname">
                </td>
                <td class="p-text-center action">
                  <p-checkbox [ngModelOptions]="{standalone: true}" [disabled]="!label.movable && label.width !== 2"
                    [value]="label" ngDefaultControl [(ngModel)]="label.checked" binary="true"
                    *ngIf="!['email', 'phone', 'social'].includes(label.code)">
                  </p-checkbox>
                </td>
                <td class="p-text-center action">
                  <p-checkbox [ngModelOptions]="{standalone: true}"
                    *ngIf="!['email', 'phone', 'social'].includes(label.code) && label.checked"
                    [disabled]="label.isrequired && !label.custom" [value]="label" ngDefaultControl
                    binary="true"></p-checkbox>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="rowexpansion" let-label>
              <tr *ngFor="let data of label.fields" class="child-color">
                <td>{{data.name}}</td>
                <td pEditableColumn class="action">
                  <input [ngModelOptions]="{standalone: true}" pInputText type="text" [(ngModel)]="data.name">
                </td>
                <td class="p-text-center action">
                  <p-checkbox [ngModelOptions]="{standalone: true}" name="display" value="val"
                    [(ngModel)]="data.checked" binary="true"></p-checkbox>
                </td>
                <td class="p-text-center action">
                  <p-checkbox [ngModelOptions]="{standalone: true}" *ngIf="data.checked " [value]="label"
                    ngDefaultControl binary="true"></p-checkbox>
                </td>
                <!-- <td class="p-text-center action">
                  <p-checkbox [ngModelOptions]="{standalone: true}" *ngIf="data.checked "
                  [value]="label" ngDefaultControl binary="true"></p-checkbox>
                </td>
                <td class="p-text-center action">
                  <p-checkbox [ngModelOptions]="{standalone: true}" *ngIf="data.checked "
                  [value]="label" ngDefaultControl binary="true"></p-checkbox>
                </td> -->
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
      <div class="p-grid">
        <div class="p-col-12">
          <p-table [value]="selectedContactLabels_address" dataKey="id" styleClass="editable">
            <ng-template pTemplate="header">
              <tr>
                <th class="header p-col-4">
                  <h5>{{'Configuration.CRM.Contact_Address' | transloco}}</h5>
                </th>
                <th class="header p-col-6"></th>
                <th style="width: 50px;" class="p-text-center header">
                  <p-checkbox [ngModelOptions]="{standalone: true}" (click)="selectedContactRow2(ct2.checked)" #ct2
                    ngDefaultControl [(ngModel)]="selectedContactCheck2" binary="true"></p-checkbox>
                </th>
                <th style="width: 50px;" class="p-text-center header">
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-label>
              <tr>
                <td>{{label.name}}
                  <span style="color: red;" *ngIf="label.movable == false">*</span>
                </td>
                <td pEditableColumn class="action">
                    <input [ngModelOptions]="{standalone: true}" pInputText type="text" [(ngModel)]="label.labelname">
                </td>
                <td class="p-text-center action">
                  <p-checkbox [ngModelOptions]="{standalone: true}" name="display" [disabled]="!label.movable"
                    [value]="label" binary="true"></p-checkbox>
                </td>
                <td class="p-text-center action">
                  <p-checkbox [ngModelOptions]="{standalone: true}" name="display" [disabled]="!label.movable"
                    [value]="label" binary="true"></p-checkbox>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
      <div class="p-grid">
        <div class="p-col-12">
          <p-table [value]="selectedContactLabels_addition" dataKey="id" class="editable">
            <ng-template pTemplate="header">
              <tr>
                <th class="header p-col-4">
                  <h5>{{'Configuration.CRM.Contact_Additional' | transloco}}</h5>
                </th>
                <th class="header p-col-6"></th>
                <th style="width: 50px;" class="p-text-center header">
                  <p-checkbox [ngModelOptions]="{standalone: true}" (click)="selectedContactRow3(ct3.checked)" #ct3
                    ngDefaultControl [(ngModel)]="selectedContactCheck3" binary="true"></p-checkbox>
                </th>
                <th style="width: 50px;" class="p-text-center header">
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-label>
              <tr>
                <td>{{label.name}}
                  <span style="color: red;" *ngIf="label.movable == false">*</span>
                </td>
                <td pEditableColumn class="action">
                  <input [ngModelOptions]="{standalone: true}" pInputText type="text" [(ngModel)]="label.labelname">
                </td>
                <td class="p-text-center action">
                  <p-checkbox [ngModelOptions]="{standalone: true}" name="display" [disabled]="!label.movable"
                    value="val" [(ngModel)]="label.checked" binary="true"></p-checkbox>
                </td>
                <td class="p-text-center action">
                  <p-checkbox [ngModelOptions]="{standalone: true}" name="display" [disabled]="!label.movable"
                    [value]="label" binary="true"></p-checkbox>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </form>
  <p-footer>
    <button type="button" pButton (click)="updateContactTemplateCancel()"
      label="{{'Configuration.CRM.Cancel' | transloco}}" class="p-button-secondary"></button>
    <button type="button" pButton label="{{'Configuration.CRM.Save' | transloco}}"
      (click)="updateContactTemplate()"></button>
  </p-footer>
</p-dialog>

<p-dialog header="{{'Configuration.CRM.Contact_Labels_Swap' | transloco}}" [(visible)]="displaySwapContactLabels"
  [modal]="true" [style]="{width: '60vw'}">
  <div class="header">
    <h5>{{'Configuration.CRM.Contact_Information' | transloco}}</h5>
  </div>
  <div class="card" cdkDropListGroup>
    <div class="p-grid" cdkDropList [cdkDropListData]="selectedContactLabels_info"
      (cdkDropListDropped)="dropContact($event)">
      <ng-container *ngFor="let s of selectedContactLabels_info">
        <div [ngClass]="{'p-col-12 p-lg-3':s.width=='3'}" [cdkDragDisabled]="s.movable==false" cdkDrag
          *ngIf="s.showForDrag==true">
          <label>{{s.labelname}}
            <span style="color: red;" *ngIf="s.movable==false">*</span>
          </label>
          <input type="text" pInputText disabled>
        </div>
      </ng-container>
    </div>
  </div>
  <p-footer>
    <button type="button" pButton (click)="displaySwapContactLabels=false;"
      label="{{'Configuration.CRM.Cancel' | transloco}}" class="p-button-secondary"></button>
    <button type="button" pButton (click)="saveContactLabelsSwap()" class="p-button-success"
      label="{{'Configuration.CRM.Save' | transloco}}"></button>
  </p-footer>
</p-dialog>

<!-- Add/Edit Field Data -->
<p-dialog header="{{addEditContactHeader}}" [modal]="true" [(visible)]="displayAddContactData" [style]="{width: '50vw'}"
  [baseZIndex]="10000">
  <div class="p-grid">
    <div class="p-col-12" *ngIf="showAddFieldDataArea">
      <label for="type">{{'Configuration.CRM.Fields_Type' | transloco}}<span style="color: red;">*</span></label>
      <p-dropdown [options]="currentModule =='user' ? userDataTypes : contactDataTypes"
        [(ngModel)]="selectedContactDataType" optionLabel="name" [filter]="true"
        placeholder="{{'Configuration.CRM.Select_Field_Type' | transloco}}" [ngModelOptions]="{standalone: true}"
        appendTo="body" (onChange)="getContactDataType()" #userDataType="ngModel" required></p-dropdown>
      <small *ngIf="contactDataFormSubmitted && userDataType.invalid &&
      (userDataType.touched || userDataType.dirty) ||
      fieldTypeSelectionError" class="p-invalid">
        {{'Configuration.CRM.Select_Field_Type_To_Add' | transloco}}
      </small>
    </div>
    <div class="p-col-12" *ngIf="showEditFieldDataArea">
      <div class="header">
        <h5 class="p-mb-0">
          {{'Configuration.CRM.Fields_Name' | transloco}} -- {{contactDataTypes[index].name}}
          <p-inputSwitch *ngIf="showActiveBtn" class="header-switch" [(ngModel)]="contactDataTemp.isActive"
            [ngModelOptions]="{standalone: true}" [disabled]="contactDataTemp && contactDataTemp.isDefault">
          </p-inputSwitch>
        </h5>
      </div>
    </div>
    <div class="p-col-12">
      <label for="name">{{'Configuration.CRM.Name' | transloco}} <span style="color: red;">*</span></label>
      <input type="text" pInputText [ngModel]="contactDataTemp?.name" #dataName="ngModel" required [ngClass]="{ 'p-invalid': dataName.invalid && (dataName.touched ||
      dataName.dirty) || invalidData == true}" (ngModelChange)="getChangeContact($event)"
        (ngModelChange)="contactDataTemp.name= $event">
      <small *ngIf="contactDataFormSubmitted && dataName.invalid &&
      (dataName.touched || dataName.dirty) || fieldTypeSelectionError" class="p-invalid">
        {{'Configuration.CRM.Name_is_required' | transloco}}
      </small>
      <small *ngIf="invalidData == true" class="p-invalid">
        {{'Configuration.CRM.Name_exists_in_the_list' | transloco}}
      </small>
    </div>
    <div *ngIf="selectedContactDataType?.id != 16" class="p-col-12">
      <label for="name">{{'Configuration.CRM.Description' | transloco}}</label>
      <input type="text" pInputText style="width: 100%;" [ngModel]="contactDataTemp?.description"
        (ngModelChange)="contactDataTemp.description= $event">
    </div>
    <div *ngIf="selectedContactDataType?.id == 16" class="p-col-12">
      <label for="color">Tag Color</label>
      <p-colorPicker
          id="color"
          format="hex"
          [ngModel]="color"
          (ngModelChange)="contactDataTemp.color = $event"
          appendTo="body">
      </p-colorPicker>
  </div> 
  </div>
  <ng-template pTemplate="footer">
    <button pButton (click)="displayAddContactData = false; invalidData = false;"
      label="{{'Configuration.CRM.Cancel' | transloco}}" class="p-button-secondary">
    </button>
    <button pButton (click)="saveContactDataAdd()" label="{{'Configuration.CRM.Save' | transloco}}"></button>
  </ng-template>
</p-dialog>

<p-dialog header="Edit Tags" [modal]="true" [(visible)]="displayEditTag" [style]="{width: '50vw'}" [baseZIndex]="10000">
  <div class="p-col-12">
    <div class="header">
      <h5 class="p-mb-0">{{'Configuration.CRM.Fields_Name' | transloco}} -- Tags
        <p-inputSwitch class="header-switch" [ngModelOptions]="{standalone: true}" [(ngModel)]="tempTag.isActive">
        </p-inputSwitch>
      </h5>
    </div>
  </div>
  <div class="card" style="min-height: 300px;">
    <div class="p-grid">
      <div class="p-col-12">
        <label>Tag Name</label>
        <input type="text" pInputText [(ngModel)]="tempTag.name">
      </div>
    </div>
    <div class="p-grid">
      <div class="p-col-12">
        <label>Tag color</label>
        <p-colorPicker [(ngModel)]="tempTag.color" appendTo="body"></p-colorPicker>
      </div>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button pButton label="Cancel" (click)='displayEditTag=false' class="p-button-secondary"></button>
    <button pButton (click)="saveTag();" label="Save"></button>
  </ng-template>
</p-dialog>
